import { observer } from 'mobx-react-lite'
import React from 'react'
import { DropdownContent, DropdownItem, Typography } from 'shared/ui'
import { useBreakdownFilterContext } from 'pages/analytics/ui/BreakdownFilter/context/breakdownFilterContext'
import styles from './styles.module.scss'

type BreakdownFilterInitContentProps = {
  isAdditionalFilters?: boolean
}

export const BreakdownFilterTypesContent = observer(
  ({ isAdditionalFilters = false }: BreakdownFilterInitContentProps) => {
    const {
      breakdownFilterTypes,
      additionalFilterTypesItems,
      addFilterType,
      filterTypes,
      hasFilters,
    } = useBreakdownFilterContext()

    const filterList = isAdditionalFilters ? additionalFilterTypesItems : breakdownFilterTypes

    return (
      <DropdownContent className={styles.dropdownContent}>
        {!hasFilters && (
          <Typography
            variant='body-sm-medium'
            color='var(--content-primary-tertiary)'
            ariaLabel='BreakdownFilterInitContentTitle'
            className={styles.initContentTitle}
          >
            Breakdown by
          </Typography>
        )}

        {filterList
          .filter((item) => filterTypes.indexOf(item.type) === -1)
          .map((item) => (
            <DropdownItem
              key={item.id}
              item={{ ...item, iconL: item.icon, className: styles.dropdownItem }}
              onChange={() => addFilterType(item.type)}
            />
          ))}
      </DropdownContent>
    )
  }
)
